/* TN 2026 — Build Your Box + Shape finder (approved Figma 28 Oct).
   Shared pricing must match the cart exactly. Appstle Bundles works in DOLLARS
   with float maths and rounds each LINE to the cent:
     discount = round(dollars x rate)  — see lineAt(); proven on 8 real carts.
   One-time: 1 pack full, 2 packs 20%, 3+ 25%. Subscribe: 10% / 25% / 30%.
   The tier counts EVERY pack across shapes. Same shape twice = one line of 2.
   URL params — Build Your Box: ?shapes=a,b  ?zone=forehead,11s,eyes,mouth  ?mode=sub
                Shape finder: ?zone=forehead,11s,crows,laugh,marionette,lips */
(function(){
  if (window.TNBox) return;

  function lineAt(base, n, pct){ var l = base * n; return l - Math.round((l / 100) * (pct / 100) * 100); }
  function tierOne(n){ return n >= 3 ? 25 : (n >= 2 ? 20 : 0); }
  function tierSub(n){ return n >= 3 ? 30 : (n >= 2 ? 25 : 10); }
  function moneyFor(cur){
    return function(c){
      try { return new Intl.NumberFormat(undefined, { style:'currency', currency: cur || 'USD' }).format(c / 100); }
      catch(e){ return '$' + (c / 100).toFixed(2); }
    };
  }
  function weeks(name){ var m = String(name).match(/\d+/); return m ? Number(m[0]) : 999; }

  var SHAPES = {
    'triangle': { zones:['forehead','11s','eyes','mouth'], tryFor:'crow’s feet or smile lines', row:'Goes right on any single line', where:'Triangle goes right on any single line.' },
    'curve':    { zones:['11s','eyes','mouth'], tryFor:'curved lines at the eyes or mouth', row:'Follows curved lines at the eyes, mouth or chin', where:'Curve follows curved lines at the eyes, mouth or chin.' },
    'y-shape':  { zones:['11s','eyes','mouth'], tryFor:'the 11s between the brows', row:'Sits between your brows for the 11s', where:'Y-Shape goes between the brows, over the 11s.' },
    'grooves':  { zones:['forehead'], tryFor:'forehead lines', row:'Follows horizontal forehead lines', where:'Grooves sits across the forehead.' },
    'jet':      { zones:['forehead','11s'], tryFor:'forehead and 11s in one patch', row:'Covers the forehead and the 11s in one piece', where:'Jet covers the forehead and the 11s in one piece.' },
    'dolphin':  { zones:['mouth'], tryFor:'smile and marionette lines', row:'Follows the smile line down toward the chin', where:'Dolphin follows the smile line beside the mouth.' }
  };

  function headerSectionId(){
    var el = document.querySelector('cart-drawer-component') || document.querySelector('cart-icon');
    if (!el) return null;
    var s = el.closest('[id^="shopify-section-"]');
    return s ? s.id.replace('shopify-section-', '') : null;
  }
  function addToCart(items, btn, done){
    var sid = headerSectionId();
    var payload = { items: items }; if (sid) payload.sections = sid;
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify(payload) })
      .then(function(r){ if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(added){
        var html = added.sections && sid ? added.sections[sid] : null;
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fi = doc.querySelector('.cart-drawer__inner'), li = document.querySelector('.cart-drawer__inner');
          if (fi && li) li.innerHTML = fi.innerHTML;
          var fd = doc.querySelector('.cart-drawer__dialog'), ld = document.querySelector('.cart-drawer__dialog');
          if (fd && ld) ld.classList.toggle('cart-drawer--empty', fd.classList.contains('cart-drawer--empty'));
          var fc = doc.querySelector('cart-icon'), lc = document.querySelector('cart-icon');
          if (fc && lc) { lc.innerHTML = fc.innerHTML; lc.className = fc.className; }
        }
        return fetch('/cart.js').then(function(r){ return r.json(); });
      })
      .then(function(cart){
        try { sessionStorage.setItem('cart-count', JSON.stringify({ value: String(cart.item_count), timestamp: Date.now() })); } catch(x){}
        document.dispatchEvent(new CustomEvent('tn:cart-changed'));
        var d = document.querySelector('cart-drawer-component');
        if (d && typeof d.open === 'function') setTimeout(function(){ try { d.open(); } catch(x){} }, 60);
      })
      .catch(function(){ window.location.href = '/cart'; })
      .finally(function(){ if (btn) btn.disabled = false; if (done) done(); });
  }
  function itemsFor(P, qty, mode, cad){
    return Object.keys(qty).filter(function(h){ return qty[h] > 0 && P[h]; }).map(function(h){
      var o = { id: Number(P[h].v), quantity: qty[h] };
      if (mode === 'sub' && P[h].plans && P[h].plans[cad]) o.selling_plan = Number(P[h].plans[cad]);
      return o;
    });
  }
  function priceFor(P, qty, pct){
    return Object.keys(qty).reduce(function(s, h){ return qty[h] > 0 && P[h] ? s + lineAt(P[h].p, qty[h], pct) : s; }, 0);
  }
  function fullFor(P, qty){
    return Object.keys(qty).reduce(function(s, h){ return qty[h] > 0 && P[h] ? s + P[h].p * qty[h] : s; }, 0);
  }
  function countOf(qty){ return Object.keys(qty).reduce(function(s, h){ return s + (qty[h] || 0); }, 0); }
  function readData(root){ var el = root.querySelector('[data-tn-data]'); try { return JSON.parse(el.textContent); } catch(e){ return null; } }
  function cadenceFor(D){
    var any = D.products[D.order[0]] || {};
    var names = Object.keys(any.plans || {}).sort(function(a, b){ return weeks(a) - weeks(b); });
    var cad = D.cadence || 'Every 6 weeks';
    try {
      var rem = sessionStorage.getItem('tn-cadence');
      if (rem) names.forEach(function(n){ if (String(any.plans[n]) === String(rem)) cad = n; });
    } catch(e){}
    if (names.length && names.indexOf(cad) === -1) cad = names[0];
    return { names: names, cad: cad, plans: any.plans || {} };
  }
  function fillCadence(sel, C, onChange){
    if (!sel) return;
    C.names.forEach(function(n){
      var o = document.createElement('option'); o.value = n; o.textContent = n.replace(/^Every /i, 'every ');
      if (n === C.cad) o.selected = true; sel.appendChild(o);
    });
    sel.addEventListener('change', function(){
      C.cad = sel.value;
      try { sessionStorage.setItem('tn-cadence', String(C.plans[C.cad])); } catch(e){}
      if (onChange) onChange();
    });
  }
  function param(name){ try { return new URLSearchParams(location.search).get(name); } catch(e){ return null; } }

  /* ================= BUILD YOUR BOX ================= */
  function initBYB(root){
    var D = readData(root); if (!D) return;
    var P = D.products, money = moneyFor(D.currency), C = cadenceFor(D);
    var qty = {}, zones = {}, mode = 'one', userMode = false;
    var $ = function(s){ return root.querySelector(s); }, $$ = function(s){ return root.querySelectorAll(s); };

    function setMode(m, byUser){ mode = m; if (byUser) userMode = true; $$('[data-mode]').forEach(function(i){ i.checked = i.value === mode; }); }
    function add(h, d){ if (!P[h]) return; qty[h] = Math.max(0, (qty[h] || 0) + d); render(); }

    function suggest(){
      var zs = Object.keys(zones).filter(function(z){ return zones[z]; });
      var pool = D.order.filter(function(h){ return !qty[h] && P[h] && P[h].av; });
      for (var i = 0; i < pool.length; i++) {
        var m = SHAPES[pool[i]];
        if (m && zs.some(function(z){ return m.zones.indexOf(z) !== -1; })) return pool[i];
      }
      if (pool.indexOf('triangle') !== -1) return 'triangle';
      return pool[0] || null;
    }

    function render(){
      var n = countOf(qty);
      if (!userMode) setMode(n >= 2 ? 'sub' : 'one');
      var zs = Object.keys(zones).filter(function(z){ return zones[z]; });

      $$('[data-zone]').forEach(function(b){ b.setAttribute('aria-pressed', zones[b.dataset.zone] ? 'true' : 'false'); });
      $$('[data-card]').forEach(function(c){
        var h = c.dataset.card, q = qty[h] || 0, m = SHAPES[h];
        var match = !!(m && zs.length && zs.some(function(z){ return m.zones.indexOf(z) !== -1; }));
        c.classList.toggle('is-match', match);
        c.style.order = match ? 0 : 1;
        c.classList.toggle('is-in', q > 0);
        var qe = c.querySelector('[data-qty]'); if (qe) qe.textContent = q + ' in box';
      });

      var list = $('[data-sum-list]');
      if (list) {
        list.innerHTML = '';
        D.order.forEach(function(h){
          if (!qty[h]) return;
          var li = document.createElement('li');
          li.innerHTML = '<span>' + P[h].t + ' &times; ' + qty[h] + '</span><span class="tn-num">' + money(P[h].p * qty[h]) + '</span>' +
            '<button type="button" aria-label="Remove one ' + P[h].t + '" data-rm="' + h + '">&minus;</button>';
          list.appendChild(li);
        });
      }
      var empty = $('[data-sum-empty]'); if (empty) empty.hidden = n > 0;
      $$('[data-prog]').forEach(function(s){ var k = Number(s.dataset.prog); s.classList.toggle('is-on', k === 3 ? n >= 3 : n >= k); });

      var op = tierOne(n), sp = tierSub(n), nextOp = tierOne(n + 1), nextSp = tierSub(n + 1);
      var nudge = $('[data-nudge]'), sugEl = $('[data-sug]');
      if (nudge) {
        if (n === 0) nudge.textContent = 'Add a shape to start your box. Mix any shapes.';
        else if (n < 3) nudge.textContent = 'Add 1 more pack and save ' + (mode === 'sub' ? nextSp : nextOp) + '%';
        else nudge.textContent = 'Best price reached: 25% off, or 30% when you subscribe.';
      }
      if (sugEl) {
        var s = n > 0 && n < 3 ? suggest() : null;
        sugEl.hidden = !s;
        if (s) { sugEl.querySelector('[data-sug-t]').textContent = 'Try ' + P[s].t + ' for ' + SHAPES[s].tryFor; sugEl.querySelector('[data-sug-add]').dataset.sugAdd = s; }
      }

      var full = fullFor(P, qty), subT = priceFor(P, qty, sp), oneT = priceFor(P, qty, op);
      var set = function(sel, v){ var e = $(sel); if (e) e.innerHTML = v; };
      set('[data-subt]', 'Subscribe &middot; save ' + sp + '%');
      set('[data-onet]', 'One-time' + (op ? ' &middot; save ' + op + '%' : ''));
      set('[data-subp]', n ? money(subT) + '<s>' + money(full) + '</s>' : '');
      set('[data-onep]', n ? money(oneT) + (op ? '<s>' + money(full) + '</s>' : '') : '');
      var cadWrap = $('[data-cadwrap]'); if (cadWrap) cadWrap.hidden = mode !== 'sub';
      var total = mode === 'sub' ? subT : oneT, pct = mode === 'sub' ? sp : op;
      set('[data-subtotal]', money(full));
      var sv = $('[data-savings-row]'); if (sv) sv.hidden = !(n && full - total > 0);
      set('[data-savings-l]', 'Box savings (' + pct + '%)');
      set('[data-savings]', '&minus;' + money(full - total));
      set('[data-ship]', (mode === 'sub' || n >= 2) ? 'Free' : 'At checkout');
      set('[data-total]', money(total));
      var night = n ? total / (n * (D.nights || 30)) : 0;
      set('[data-night]', n ? 'about ' + (night < 100 ? Math.round(night) + '&cent;' : money(Math.round(night))) + ' a night' : '');
      var btn = $('[data-add-box]');
      var avail = Object.keys(qty).every(function(h){ return !qty[h] || P[h].av; });
      if (btn) { btn.disabled = !n || !avail; btn.textContent = n ? 'Add box to bag' : 'Add a shape to start'; }
      var bar = $('[data-bar]');
      if (bar) { bar.hidden = !n; var bt = bar.querySelector('[data-bar-t]'); if (bt) bt.textContent = n + (n === 1 ? ' pack' : ' packs') + ' · ' + money(total); }
    }

    root.addEventListener('click', function(e){
      var t;
      if ((t = e.target.closest('[data-zone]'))) { zones[t.dataset.zone] = !zones[t.dataset.zone]; render(); return; }
      if ((t = e.target.closest('[data-inc]'))) { add(t.closest('[data-card]').dataset.card, 1); return; }
      if ((t = e.target.closest('[data-dec]'))) { add(t.closest('[data-card]').dataset.card, -1); return; }
      if ((t = e.target.closest('[data-rm]'))) { add(t.dataset.rm, -1); return; }
      if ((t = e.target.closest('[data-sug-add]'))) { if (t.dataset.sugAdd) add(t.dataset.sugAdd, 1); return; }
      if ((t = e.target.closest('[data-combo]'))) {
        e.preventDefault();
        t.dataset.combo.split(',').forEach(function(h){ h = h.trim(); if (P[h] && !qty[h]) qty[h] = 1; });
        render();
        var sum = $('[data-sum]'); if (sum && window.innerWidth < 900) sum.scrollIntoView({ behavior:'smooth', block:'start' });
        return;
      }
      if ((t = e.target.closest('[data-more]'))) { var x = $('[data-extra]'); if (x) { x.hidden = !x.hidden; t.textContent = x.hidden ? t.dataset.more : t.dataset.less; } return; }
      if ((t = e.target.closest('[data-add-box],[data-bar-btn]'))) {
        e.preventDefault();
        var items = itemsFor(P, qty, mode, C.cad); if (!items.length) return;
        addToCart(items, t, render);
      }
    });
    $$('[data-mode]').forEach(function(i){ i.addEventListener('change', function(){ if (i.checked) { setMode(i.value, true); render(); } }); });
    fillCadence($('[data-cad]'), C);

    var pz = param('zone'); if (pz) pz.split(',').forEach(function(z){ zones[z.trim()] = true; });
    var ps = param('shapes'); if (ps) ps.split(',').forEach(function(h){ h = h.trim(); if (P[h]) qty[h] = (qty[h] || 0) + 1; });
    var pm = param('mode'); if (pm === 'sub' || pm === 'one') setMode(pm, true);
    render();
  }

  /* ================= SHAPE FINDER ================= */
  var ZONE_ORDER = ['forehead','11s','crows','laugh','marionette','lips'];
  var ZONE_TXT = { forehead:'forehead lines', '11s':'the 11s', crows:'crow’s feet', laugh:'laugh lines', marionette:'marionette lines and the chin', lips:'lines around the lips' };
  var DEPTH_TXT = { fine:' that soften by midday', stay:' that stay through the day', deep:' that have set in', unsure:'' };
  function joinAnd(a){ return a.length < 2 ? (a[0] || '') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }

  function pickShapes(zs, depth){
    var out = [], why = {};
    function push(h, z){ if (out.indexOf(h) === -1) { out.push(h); why[h] = z; } }
    if (zs.forehead) push('grooves', 'forehead');
    if (zs['11s']) push('y-shape', '11s');
    if (zs.crows) push('curve', 'crows');
    if (zs.laugh) push(depth === 'fine' || depth === 'unsure' ? 'triangle' : 'dolphin', 'laugh');
    if (zs.marionette) push('curve', 'marionette');
    if (zs.lips) push('triangle', 'lips');
    return { shapes: out.slice(0, 3), extra: out.slice(3), why: why };
  }

  function initFinder(root){
    var D = readData(root); if (!D) return;
    var P = D.products, money = moneyFor(D.currency), C = cadenceFor(D);
    var $ = function(s){ return root.querySelector(s); }, $$ = function(s){ return root.querySelectorAll(s); };
    var A = { zones:{}, depth:'stay', goal:'routine' }, qty = {}, mode = 'sub', R = null;

    function show(step){
      $$('[data-q]').forEach(function(q){ q.hidden = q.dataset.q !== String(step); });
      var res = $('[data-result]'); if (res) res.hidden = step !== 'r';
      root.scrollIntoView({ behavior:'smooth', block:'start' });
    }
    function syncInputs(){
      $$('[data-z]').forEach(function(b){ b.setAttribute('aria-pressed', A.zones[b.dataset.z] ? 'true' : 'false'); });
      $$('[data-d]').forEach(function(b){ b.setAttribute('aria-pressed', A.depth === b.dataset.d ? 'true' : 'false'); });
      $$('[data-g]').forEach(function(b){ b.setAttribute('aria-pressed', A.goal === b.dataset.g ? 'true' : 'false'); });
      var n1 = $('[data-next="2"]'); if (n1) n1.disabled = !Object.keys(A.zones).some(function(z){ return A.zones[z]; });
    }

    function build(){
      R = pickShapes(A.zones, A.depth);
      qty = {};
      if (R.shapes.length === 1) qty[R.shapes[0]] = 2; else R.shapes.forEach(function(h){ qty[h] = 1; });
      mode = A.goal === 'first' ? 'one' : 'sub';
      renderResult();
    }

    function renderResult(){
      var hs = Object.keys(qty).filter(function(h){ return qty[h] > 0; });
      var n = countOf(qty);
      var names = hs.map(function(h){ return P[h].t; });
      var zt = ZONE_ORDER.filter(function(z){ return A.zones[z]; }).map(function(z){ return ZONE_TXT[z]; });
      $('[data-r-title]').textContent = hs.length === 1 && qty[hs[0]] === 2 ? 'Two packs of ' + names[0] : names.join(' + ');
      $('[data-r-desc]').textContent = 'For ' + joinAnd(zt) + (DEPTH_TXT[A.depth] || '') + '.' + (hs.length > 1 ? ' Wear them on the same night, or alternate.' : ' About two months of nights.');
      var key = hs.slice().sort().join('+');
      var img = $('[data-r-img]'), src = D.tiles[key] || D.overlays[hs[0]];
      if (img) { img.hidden = !src; if (src) img.src = src; img.alt = 'Where ' + joinAnd(names) + ' go on the face'; }
      $('[data-r-where]').textContent = hs.map(function(h){ return SHAPES[h] ? SHAPES[h].where : ''; }).join(' ');
      var rows = $('[data-r-rows]'); rows.innerHTML = '';
      hs.forEach(function(h){
        var ic = root.querySelector('template[data-icon="' + h + '"]');
        var d = document.createElement('div'); d.className = 'tnf-row';
        d.innerHTML = '<span class="tnf-row__i">' + (ic ? ic.innerHTML : '') + '</span><span><b>' + P[h].t + '</b><small>' + (SHAPES[h] ? SHAPES[h].row : '') + '</small></span>';
        rows.appendChild(d);
      });
      var op = tierOne(n), sp = tierSub(n), full = fullFor(P, qty);
      $('[data-r-subt]').innerHTML = 'Subscribe &middot; ' + sp + '% off';
      $('[data-r-subp]').innerHTML = money(priceFor(P, qty, sp)) + '<s>' + money(full) + '</s>';
      $('[data-r-onet]').innerHTML = 'One-time' + (op ? ' &middot; ' + op + '% off' : '');
      $('[data-r-ones]').textContent = n + (n === 1 ? ' pack' : ' packs') + ', any shapes';
      $('[data-r-onep]').innerHTML = money(priceFor(P, qty, op)) + (op ? '<s>' + money(full) + '</s>' : '');
      $$('[data-r-mode]').forEach(function(i){ i.checked = i.value === mode; });
      var cw = $('[data-cadwrap]'); if (cw) cw.hidden = mode !== 'sub';
      var tot = priceFor(P, qty, mode === 'sub' ? sp : op);
      $('[data-r-add]').textContent = 'Add my box · ' + money(tot);
      var third = $('[data-r-third]'), ex = R.extra.filter(function(h){ return !qty[h]; })[0];
      if (third) {
        third.hidden = !ex || n >= 3;
        if (ex) { third.dataset.h = ex; third.textContent = 'Add ' + P[ex].t + ' for ' + ZONE_TXT[R.why[ex]] + ': 3 packs save 25% one-time, 30% on subscription →'; }
      }
      var jet = $('[data-r-jet]'); if (jet) jet.hidden = !(qty['grooves'] && qty['y-shape']);
      var inj = $('[data-r-inj]'); if (inj) inj.hidden = A.goal !== 'between';
      var tr = $('[data-r-trial]'); if (tr) tr.classList.toggle('is-strong', A.goal === 'first');
      var byb = $('[data-r-byb]');
      if (byb) {
        var list = []; hs.forEach(function(h){ for (var i = 0; i < qty[h]; i++) list.push(h); });
        byb.href = (D.bybUrl || '/pages/build-your-ritual') + '?shapes=' + list.join(',') + (mode === 'sub' ? '&mode=sub' : '');
      }
    }

    root.addEventListener('click', function(e){
      var t;
      if ((t = e.target.closest('[data-z]'))) { A.zones[t.dataset.z] = !A.zones[t.dataset.z]; syncInputs(); return; }
      if ((t = e.target.closest('[data-d]'))) { A.depth = t.dataset.d; syncInputs(); return; }
      if ((t = e.target.closest('[data-g]'))) { A.goal = t.dataset.g; syncInputs(); return; }
      if ((t = e.target.closest('[data-next]'))) { if (t.dataset.next === 'r') { build(); show('r'); } else show(Number(t.dataset.next)); return; }
      if ((t = e.target.closest('[data-back]'))) { show(Number(t.dataset.back)); return; }
      if ((t = e.target.closest('[data-edit]'))) { show(1); return; }
      if ((t = e.target.closest('[data-r-third]'))) { if (t.dataset.h) { qty[t.dataset.h] = 1; renderResult(); } return; }
      if ((t = e.target.closest('[data-r-jet]'))) { delete qty['grooves']; delete qty['y-shape']; qty['jet'] = (qty['jet'] || 0) + (countOf(qty) ? 1 : 2); renderResult(); return; }
      if ((t = e.target.closest('[data-r-add]'))) { e.preventDefault(); addToCart(itemsFor(P, qty, mode, C.cad), t, renderResult); }
    });
    $$('[data-r-mode]').forEach(function(i){ i.addEventListener('change', function(){ if (i.checked) { mode = i.value; renderResult(); } }); });
    fillCadence($('[data-cad]'), C);

    var map = { forehead:'forehead', '11s':'11s', eyes:'crows', crows:'crows', laugh:'laugh', smile:'laugh', mouth:'laugh', marionette:'marionette', chin:'marionette', lips:'lips' };
    var pz = param('zone'); if (pz) pz.split(',').forEach(function(z){ var k = map[z.trim()]; if (k) A.zones[k] = true; });
    syncInputs();
  }

  window.TNBox = { lineAt: lineAt, tierOne: tierOne, tierSub: tierSub };
  function boot(){
    document.querySelectorAll('[data-byb]').forEach(initBYB);
    document.querySelectorAll('[data-finder]').forEach(initFinder);
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
